import { render } from "./KeywordTips.vue?vue&type=template&id=566d62f4"
import script from "./KeywordTips.vue?vue&type=script&lang=js"
export * from "./KeywordTips.vue?vue&type=script&lang=js"

import "./KeywordTips.vue?vue&type=style&index=0&id=566d62f4&lang=scss"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__